import { logger } from '@/utils/logger';
import { BankConnectionSuccess } from '@/components/accounts/BankConnectionSuccess';
import appServices from '@/services/appServices';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { number, object, string } from 'zod';

const GocardlessCallbackSearchSchema = object({
  //   requisition_id: string(),
  ref: number(),
  error: string().optional(),
});
export const Route = createFileRoute('/gocardless-callback')({
  component: RouteComponent,
  validateSearch: zodValidator(GocardlessCallbackSearchSchema),
});

function RouteComponent() {
  const { ref: reference, error } = Route.useSearch();
  logger.debug('GoCardless callback params:', reference, error);

  // Detect if we're in onboarding context by checking user settings
  const userSettings = appServices.auth.getUserSettings();
  const isOnboarding = userSettings?.onboarding_completed !== 'true';

  logger.debug('GoCardless callback - isOnboarding:', isOnboarding);

  return (
    <BankConnectionSuccess
      bankName={''}
      requisitionReference={reference.toString()}
      isOnboarding={isOnboarding}
    />
  );
}
